import { resolveTenantFavicon } from '@delta/domain';
import { useEffect } from 'react';
import { useTenant } from '../tenant/TenantContext';
import { useTenantBranding } from './tenantBranding';

export function TenantBrowserIcon() {
  const tenant = useTenant();
  const { data } = useTenantBranding();
  const url = resolveTenantFavicon(data, tenant.id);
  useEffect(() => {
    const icon = document.querySelector<HTMLLinkElement>('#tenant-favicon');
    if (!icon) return;
    const reset = () => { icon.onerror = null; icon.href = '/favicon.svg'; icon.type = 'image/svg+xml'; };
    reset();
    if (url) { icon.removeAttribute('type'); icon.href = url; icon.onerror = reset; }
    return () => { icon.onerror = null; reset(); };
  }, [url]);
  return null;
}
